<template>
    <div class="elder-family">
        <mt-header fixed title="子女信息编辑">
            <router-link :to="'/elder/family/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <div class="children-info" style="margin-bottom:10px" v-for="(child,index) in children">
                <mt-field label="子女姓名" placeholder="输入子女姓名" v-model="child['姓名']"></mt-field>
                <mt-field label="子女联系方式" placeholder="输入子女联系方式"  v-model="child['电话']"></mt-field>
                <a style="background:#fff;padding-left:10px;padding-bottom:10px;color:red;width:100%;display:block" @click="removeChild(index)">删除该信息</a>
            </div>
            <p style="text-align: center" v-if="children.length === 0">暂未设置子女信息</p>

            <div class="new-form-button">
                <mt-button size="large" type="primary" style="margin-bottom:10px" @click="addChild">添加子女信息</mt-button>
                <mt-button size="large" type="primary" @click="save">保存</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        data() {
            return {
                openid: JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id: this.$route.params.id,
                children:[]
            }
        },

        methods:{
            addChild(){
                let child = { }
                child['姓名'] = ''
                child['电话'] = ''
                this.children.push(child)
            },

            removeChild(index){
                this.children.splice(index,1);
            },

            save(){
                let params = {
                    openid:this.openid,elder:this.id,is_children:1
                }
                if(this.children.length>0){
                    for(let i =0;i<this.children.length;i++){
                        if(this.children[i]['姓名'] === ''||this.children[i]['电话'] === ''){
                            this.$toast('请输入完整的姓名和电话信息');
                            return false;
                        }

                        params['children'] = JSON.stringify(this.children)
                    }
                }else{
                    params['children'] = null;
                }

                this.$indicator.open('加载中');
                this.$axios.post("/elder/family",params)
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {

                            this.$toast('保存成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){
            this.$axios.get('/elder/family?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        let family_info = data.data.data;
                        if(family_info!==null){
                            this.children = family_info.children;
                            console.log(this.children);
                        }

                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/elder/familyChildren.vue